var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mini-loader"},[_c('div',{staticClass:"spinner"},_vm._l(([0,1,2,3,4,5,6,7,8,9,10,11]),function(i){return _c('div',{key:i})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }